export default {
  countryCode: 'SG',
  regionLinks: [
    {
      title: 'Singapore',
    },
  ],
};
